/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:44dd853d-da91-4197-b3b7-5b1d0ac43e15",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_QliKS7pIz",
    "aws_user_pools_web_client_id": "6lh3pn643bt13nvepdt2a9ru92",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 6,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://wtmailvcn5brrh5znlo6wpzr44.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-5mtuzekgsjha3czcy2fldnu22i",
    "aws_user_files_s3_bucket": "simpli-store-storage-f63e07bb164228-dev",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
